// The local day, updated at midnight and when the app comes back to the front.
import { useEffect, useState } from 'react';
import { todayKey, type DayKey } from '../../shared/days';

export function useToday(): DayKey {
  const [today, setToday] = useState(todayKey);
  useEffect(() => {
    let timer: number | undefined;
    const update = () => {
      setToday(todayKey());
      window.clearTimeout(timer);
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 1);
      timer = window.setTimeout(update, midnight.getTime() - now.getTime());
    };
    update();
    const onVisible = () => {
      if (document.visibilityState === 'visible') update();
    };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', update);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', update);
    };
  }, []);
  return today;
}
